import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/lib/api-client'

export interface AuditImageDefaults {
  resolution: string
  aspect_ratio: string
  generation_count: number
}

const QUERY_KEY = ['audit-image-defaults']

const INITIAL_DEFAULTS: AuditImageDefaults = {
  resolution: '1k',
  aspect_ratio: '1:1',
  generation_count: 1,
}

export function useAuditImageDefaults() {
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await apiClient.get<AuditImageDefaults>('/api/v2/amazon/image-defaults')
      return res.data
    },
    staleTime: 5 * 60 * 1000,
  })

  const mutation = useMutation({
    mutationFn: (defaults: AuditImageDefaults) =>
      apiClient.put('/api/v2/amazon/image-defaults', defaults),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY }),
  })

  return {
    defaults: data ?? INITIAL_DEFAULTS,
    isLoading,
    saveDefaults: mutation.mutate,
    isSaving: mutation.isPending,
  }
}
